import {
	$$,
	ComponentOptions,
	IComponentBindings,
	Initialization,
	IQuerySuccessEventArgs,
	QueryEvents,
	ResultListEvents
	} from 'coveo-search-ui';

import { AtlasComponent } from "./../models/AtlasComponent";

export interface ILoadMoreOptions {
	resultsPerPage: number;
}

export class ShowMore extends AtlasComponent {
	static ID = 'ShowMore';
	private isLoaded = false;
	private resultList: Coveo.ResultList;
	private resultsCount: number = 0;

	static options: ILoadMoreOptions = {
		resultsPerPage: ComponentOptions.buildNumberOption({
			defaultValue: 20
		})
	};

	constructor(public element: HTMLElement, public options: ILoadMoreOptions, public bindings: IComponentBindings) {
		super(element, ShowMore.ID, bindings);
		this.options = ComponentOptions.initComponentOptions(element, ShowMore, options);
		this.resultList = (Coveo.get($(".Coveo" + Coveo.ResultList.ID)[0], Coveo.ResultList) as Coveo.ResultList);
		this.resultsCount = 0;
		// Event listeners
		this.bind.onRootElement(QueryEvents.querySuccess, this.querySuccess.bind(this));
		this.bind.onRootElement(QueryEvents.fetchMoreSuccess, this.querySuccess.bind(this));
		this.domElement.on("click", () => this.loadMore());
	}

	private querySuccess(data: IQuerySuccessEventArgs) {
		// Cannot trust value of this.resultList.hasPotentiallyMoreResultsToDisplay().
		// Reference: https://answers.coveo.com/questions/13672/why-does-resultlist-hard-code-the-value-of-thisrea.html
		this.resultsCount = data.results.results.length + data.query.firstResult;
		let hasMoreResults = this.resultsCount < data.results.totalCountFiltered;

		if (this.resultList === undefined) {
			this.resultList = (Coveo.get($(".Coveo" + Coveo.ResultList.ID)[0], Coveo.ResultList) as Coveo.ResultList);
		}

		if (this.resultsCount && hasMoreResults) {
			this.show();
		} else {
			this.hide();
		}
	}

	protected updateVisibility() {
		if (this.resultList.hasPotentiallyMoreResultsToDisplay()) {
			this.show();
		} else {
			this.hide();
		}
	}

	protected loadMore() {
		this.resultList.displayMoreResults(this.options.resultsPerPage);
	}
}

Initialization.registerAutoCreateComponent(ShowMore);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/ShowMore.ts